import { mapValues } from 'lodash-es';

import { Breakpoint } from '../../hooks/useBreakpoint/index.types';

import { ResponsiveTokens, Theme, WithBreakpoints } from '../index.types';

export const parseBreakpoints = <T extends Partial<Theme>>(
  partial: Partial<Record<keyof Theme, WithBreakpoints<object>>>,
  breakpoint: Breakpoint,
) =>
  mapValues(partial, (outerValue) => {
    return mapValues(outerValue, (value) => value[breakpoint]);
  }) as T;

export const injectInsets = (
  { spacing, ...rest }: Pick<Theme, keyof ResponsiveTokens>,
  {
    top,
    right,
    bottom,
    left,
  }: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  },
) => ({
  ...rest,
  spacing: {
    ...spacing,
    'safe-area-inset-top': top || 20,
    'safe-area-inset-top-pure': top,
    'safe-area-inset-right': right,
    'safe-area-inset-bottom': bottom || 20,
    'safe-area-inset-bottom-pure': bottom,
    'safe-area-inset-left': left,
  },
});
